import {
  Button,
  ButtonColorVariant,
  ButtonProps,
  ButtonVariant,
  Color,
  withCitrusTheme,
} from '@gousto-internal/citrus-react';
import { MENU_COLLECTION_FILTER_PADDING_H } from './MenuCollectionFilters';

type StyledArrowButtonProps = {
  direction: 'left' | 'right';
} & ButtonProps;

const ArrowButton = (props: StyledArrowButtonProps) => {
  const { direction, ...buttonProps } = props;

  return (
    <Button
      colorVariant={ButtonColorVariant.Secondary}
      variant={ButtonVariant.Icon}
      icon={`chevron_${direction}`}
      {...buttonProps}
    />
  );
};

export const MenuCollectionFilterScrollButton = withCitrusTheme(ArrowButton, (theme, props) => [
  theme.responsiveSpacing(MENU_COLLECTION_FILTER_PADDING_H, [props.direction]),
  {
    position: 'absolute',
    background: theme.color(Color.White),
    opacity: '80%',
    outline: 'none',
    boxShadow: 'none',
    color: theme.color(Color.ColdGrey_800),

    '&:hover,&:focus': {
      color: theme.color(Color.Secondary_600),
      // Suggestion 1
      boxShadow: `inset 0 0 0 2px ${theme.color(Color.Secondary_600)}`,
      opacity: 1,
    },
  },
]);
